import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./StorySection.module.scss";

const StorySection = ({ label, description, content }) => {
    return (
        <div className={cs(classes.storySectionBox)}>
            <div className={cs(classes.storyLabel)}>
                <span className={cs(classes.storyLabelRed)}>{label}:</span>{" "}
                <span className={cs(classes.storyLabelText)}>{description}</span>
            </div>
            <div className={cs(classes.underline)} />
            <div className={cs(classes.storyContentBox)}>
                <div className={cs(classes.storyText)}>{content}</div>
            </div>
        </div>
    );
};

StorySection.propTypes = {
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    rows: PropTypes.number,
};

export default StorySection;